import { createAction } from 'redux-actions';
// import {
//   CREATE_FACEBOOK_POST_SUCCESS,
//   CREATE_FACEBOOK_POST_FAILURE
// } from '../constants/actionTypes';
import * as cancel from '../api/cancelSubscription';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbar';

/* eslint-disable import/prefer-default-export */
// const createFacebookPostSuccess = createAction(CREATE_FACEBOOK_POST_SUCCESS);
// const createFacebookPostFailure = createAction(CREATE_FACEBOOK_POST_FAILURE);

export function cancelSubscription(params) {
  return dispatch => cancel.cancelSubscription(params)
    .then(({ data }) => {
      dispatch(showSuccessSnackbar('Subscription cancelled successfully'));
     // return dispatch(createFacebookPostSuccess(data));
    })
    .catch((error) => {
      if(error?.response?.status === 401){
        dispatch(showErrorSnackbar('Session is Expired!!!'));
      }else{
        // console.log("error>>>>>",error);
      dispatch(showErrorSnackbar('You have already cancelled your subscription!'));
      }
      //return dispatch(createFacebookPostFailure(error));
    });
}
